import { createSlice } from '@reduxjs/toolkit';
import {
  buyDiscountCode,
  getDiscountCodes
} from '../views/DiscountCode/DiscountCode.actions';
import { DiscountCode } from '../views/DiscountCode/DiscountCode.types';

export interface DiscountCodeSliceType {
  loading: boolean;
  buyDiscountLoading: boolean;
  discountCodes: DiscountCode[];
}

const initialState = {
  loading: false,
  buyDiscountLoading: false,
  discountCodes: []
} as DiscountCodeSliceType;

const discountCodeSlice = createSlice({
  name: 'discount-code',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getDiscountCodes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDiscountCodes.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.discountCodes = payload;
    });

    builder.addCase(getDiscountCodes.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(buyDiscountCode.pending, (state) => {
      state.buyDiscountLoading = true;
    });
    builder.addCase(buyDiscountCode.fulfilled, (state, { payload }) => {
      state.buyDiscountLoading = false;
    });

    builder.addCase(buyDiscountCode.rejected, (state) => {
      state.buyDiscountLoading = false;
    });
  }
});

// export const { changeAvailableBalance } = withdrawSlice.actions;

export default discountCodeSlice.reducer;
